import urlApi from './urlApi';
export var COUNTRY_INFO_REQUEST = 'COUNTRY_INFO_REQUEST';
export var COUNTRY_INFO_SUCCESS = 'COUNTRY_INFO_SUCCESS';
export function getCountryInfo(countryId) {
    return function (dispatch) {
        dispatch({
            type: COUNTRY_INFO_REQUEST,
        });
        urlApi().getCountryInfo(countryId).then(function (res) {
            dispatch({
                type: COUNTRY_INFO_SUCCESS,
                payload: res,
            });
        });
    };
}
//# sourceMappingURL=countryInfoAction.js.mapimport urlApi from './urlApi';
export var COUNTRY_INFO_REQUEST = 'COUNTRY_INFO_REQUEST';
export var COUNTRY_INFO_SUCCESS = 'COUNTRY_INFO_SUCCESS';
export function getCountryInfo(countryId) {
    return function (dispatch) {
        dispatch({
            type: COUNTRY_INFO_REQUEST,
        });
        urlApi().getCountryInfo(countryId).then(function (res) {
            dispatch({
                type: COUNTRY_INFO_SUCCESS,
                payload: res,
            });
        });
    };
}
//# sourceMappingURL=countryInfoAction.js.map